<button
  type="button"
  class="flex h-9 w-9 cursor-pointer items-center justify-center overflow-hidden rounded-full border-0 bg-slate-200 p-0 text-sm font-semibold text-slate-700 transition hover:bg-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400"
  aria-label="Account menu"
  [cdkMenuTriggerFor]="userMenu">
  @if (pictureUrl; as picture) {
    <img [src]="picture" alt="" class="h-full w-full object-cover" />
  } @else {
    <span>{{ initial }}</span>
  }
</button>

<ng-template #userMenu>
  <div
    cdkMenu
    class="w-72 rounded-2xl border border-slate-200 bg-white p-3 shadow-xl">
    <div class="mb-2 flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-3">
      <div class="min-w-0 flex-1">
        <p class="truncate text-sm font-semibold text-slate-900">{{ displayName }}</p>
        @if (email) {
          <p class="mt-0.5 truncate text-xs text-slate-500">{{ email }}</p>
        }
      </div>
      <span
        class="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-200 text-sm font-semibold text-slate-700">
        @if (pictureUrl; as picture) {
          <img [src]="picture" alt="" class="h-full w-full object-cover" />
        } @else {
          <span>{{ initial }}</span>
        }
      </span>
    </div>

    <button
      type="button"
      cdkMenuItem
      class="flex w-full cursor-pointer items-center gap-3 rounded-xl border-0 bg-transparent px-3 py-2.5 text-left text-sm text-slate-800 transition hover:bg-slate-100"
      (click)="onAccountSettings()">
      <app-svg-icon src="assets/icons/cog-outline.svg" [size]="18" />
      <span>Account Settings</span>
    </button>

    <div class="my-2 border-t border-slate-200"></div>

    <button
      type="button"
      cdkMenuItem
      class="flex w-full cursor-pointer items-center gap-3 rounded-xl border-0 bg-transparent px-3 py-2.5 text-left text-sm text-slate-800 transition hover:bg-slate-100"
      (click)="onLogout()">
      <app-svg-icon src="assets/icons/logout.svg" [size]="18" />
      <span>Logout</span>
    </button>
  </div>
</ng-template>
